import {
  ActivationBanner,
  SettingsLinks,
  SectionHeader,
} from "../../components";


import chevronRightIcon from "../../assets/icons/chevron-right.svg";
import linkColoredIcon from "../../assets/icons/link-colored.svg";
import cardSwipeIcon from "../../assets/icons/cardSwipe.svg";
import listPadIcon from "../../assets/icons/list-pad.svg";
import mailIcon from "../../assets/icons/mail.svg";
import recurringDarkIcon from "../../assets/icons/recurring-dark.svg";
import personDangerIcon from "../../assets/icons/person-danger.svg";
import houseBlueIcon from "../../assets/icons/house-blue.svg";
import pageLinkIcon from "../../assets/icons/page-link.svg";
import houseIcon from "../../assets/icons/house.svg";
import maskIcon from "../../assets/icons/mask.svg";
import documentTextIcon from "../../assets/icons/document-text.svg";
import peopleIcon from "../../assets/icons/people.svg";
import shieldTickIcon from "../../assets/icons/shield-tick.svg";

export const View = () => {
  const LinkIcon = ({
    iconSource,
    iconSource2,
    iconLeft,}: {
    iconSource: string;
    iconSource2?: string;
    iconLeft?: boolean;
  }) => {
    return (
      <div className=" align-icon--center">
        <img
          src={iconSource}
          alt="link icon"
          className={`${
            iconLeft ? "icon-left" : "icon-right"
          } align-icon--center`}
        />

        {!iconSource2 ? (
          <></>
        ) : (
          <img
            src={iconSource2}
            alt="link icon"
            className={`${
              iconLeft ? "icon-left" : "icon-right"
            } icon-subscript`}
          />
        )}
      </div>
    );
  };

  return (
    <>
      <ActivationBanner
        title="Please you need to activate your profile"
        subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up"
        urlTarget="/onboarding"
      />

      <div className="flex-container flex-break--small settings-container">
        <div className="flex-box section-container">
          <SectionHeader
            title="Payment Settings"
            subtitle="Add payment methods, create and manage subscriptions and invoices."
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={linkColoredIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Checkout and Payment Links"
            subtitle="Configure payment links for your customers"
            urlTarget="/checkout-and-payment-links"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={cardSwipeIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Payment methods"
            subtitle="Configure your gateways and payment options."
            urlTarget="/payment-methods"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={listPadIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Invoice template"
            subtitle="Create an invoice template and send to your customers"
            urlTarget="/invoice-template"
          />

          <SettingsLinks
            iconLeft={
              <LinkIcon
                iconSource={mailIcon}
                iconSource2={recurringDarkIcon}
                iconLeft
              />
            }
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Subscription and emails"
            subtitle="Configure the notifications you and your team receive from us."
            urlTarget="/subscriptions-and-emails"
          />
        </div>

        <div className="flex-divider" />

        <div className="flex-box section-container">
          <SectionHeader
            title="Business Settings"
            subtitle="Adjust your account details, add banks account for payout and top-ups."
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={personDangerIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Account Details"
            subtitle="Details about the account ownership."
            urlTarget="/account-details"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={houseBlueIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Business details"
            subtitle="Details about your business that your customers can see."
            urlTarget="/business-details"
          />

          <SettingsLinks
            iconLeft={
              <LinkIcon
                iconSource={personDangerIcon}
                iconSource2={pageLinkIcon}
                iconLeft
              />
            }
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Linked external accounts"
            subtitle="Accounts from other software that you have connected to this one."
            urlTarget="/linked-accounts"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={houseIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Bank accounts and currencies"
            subtitle="Add withdrawal bank accounts for different currencies"
            urlTarget="/accounts-and-currencies"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={maskIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Branding"
            subtitle="Customize the experience of your customers when using our application"
            urlTarget="/branding"
          />

          <SettingsLinks
            iconLeft={<LinkIcon iconSource={documentTextIcon} iconLeft />}
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Reporting and documents"
            subtitle="Configure the format of your report documents."
            urlTarget="/reporting"
          />

          <SettingsLinks
            iconLeft={
              <LinkIcon
                iconSource={peopleIcon}
                iconSource2={shieldTickIcon}
                iconLeft
              />
            }
            iconRight={<LinkIcon iconSource={chevronRightIcon} />}
            title="Team and security"
            subtitle="Manage your staff and team members"
            urlTarget="/team-members"
          />
        </div>
      </div>
    </>
  );
};
